import(/* webpackMode: "eager" */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BottomNav"] */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/components/BottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PixelScripts"] */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/components/PixelScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreSuspendedGate"] */ "/home/u650493134/domains/kelolify.com/hbuilds/source/repository/src/components/StoreSuspendedGate.tsx");
